var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navbar Icon",
    opacity: 0.8,
    clipPath: "url(#clip0_84618_2403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87506 10.5889C5.63445 10.5889 6.25006 9.97329 6.25006 9.2139C6.25006 8.45451 5.63445 7.8389 4.87506 7.8389C4.11567 7.8389 3.50006 8.45451 3.50006 9.2139C3.50006 9.97329 4.11567 10.5889 4.87506 10.5889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.4639C9 6.22329 8.38439 6.8389 7.625 6.8389C6.86561 6.8389 6.25 6.22329 6.25 5.4639C6.25 4.70451 6.86561 4.0889 7.625 4.0889C8.38439 4.0889 9 4.70451 9 5.4639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3751 6.8389C13.1345 6.8389 13.7501 6.22329 13.7501 5.4639C13.7501 4.70451 13.1345 4.0889 12.3751 4.0889C11.6157 4.0889 11.0001 4.70451 11.0001 5.4639C11.0001 6.22329 11.6157 6.8389 12.3751 6.8389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.2139C16.5 9.97329 15.8844 10.5889 15.125 10.5889C14.3656 10.5889 13.75 9.97329 13.75 9.2139C13.75 8.45451 14.3656 7.8389 15.125 7.8389C15.8844 7.8389 16.5 8.45451 16.5 9.2139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.375C4.875 19.375 0.625 15.125 0.625 10C0.625 4.875 4.875 0.625 10 0.625C15.125 0.625 19.375 4.375 19.375 9C19.375 12 16.875 14.5 13.875 14.5H12.125C11.75 14.5 11.375 14.875 11.375 15.25C11.375 15.5 11.5 15.625 11.625 15.75C12 16.125 12.125 16.625 12.125 17.125C12.125 18.375 11.125 19.375 10 19.375ZM10 2C5.625 2 2 5.625 2 10C2 14.375 5.625 18 10 18C10.375 18 10.75 17.625 10.75 17.25C10.75 17 10.625 16.875 10.5 16.75C10.125 16.375 10 15.875 10 15.375C10 14.25 11 13.25 12.125 13.25H13.875C16.125 13.25 18 11.375 18 9.125C18 5.125 14.375 2 10 2Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84618_2403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.94901c476165596f5225eef9af3bb981.svg";
export { ForwardRef as ReactComponent };